import { render, staticRenderFns } from "./PLMDocument.vue?vue&type=template&id=3bf6e46a&scoped=true"
import script from "./PLMDocument.vue?vue&type=script&lang=js"
export * from "./PLMDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf6e46a",
  null
  
)

export default component.exports